document.addEventListener("DOMContentLoaded", () => {
  // Independiente del bloque del drawer de abajo (que hace early return
  // si no hay menú configurado) — el estado sticky del Header no debe
  // depender de que exista un drawer.
  const header = document.querySelector(".maison-header");
  const hero = document.querySelector(".maison-hero");

  if (header && hero) {
    // Alterna .is-scrolled cuando el Hero deja de ser visible en el
    // viewport. IntersectionObserver en vez de un listener de scroll:
    // no dispara en cada frame, solo cuando el estado de intersección
    // realmente cambia.
    const heroObserver = new IntersectionObserver(
      ([entry]) => {
        header.classList.toggle("is-scrolled", !entry.isIntersecting);
      },
      { threshold: 0 },
    );

    heroObserver.observe(hero);
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.getElementById("MaisonDrawer");

  if (!drawer) return;

  const openButtons = document.querySelectorAll(".maison-header__menu-button");

  const closeButton = drawer.querySelector(".maison-drawer__close");

  const overlay = drawer.querySelector(".maison-drawer__overlay");

  const links = drawer.querySelectorAll(".maison-drawer__link");

  let activeTouchLink = null;

  function setTouchActiveLink(link) {
    if (activeTouchLink === link) return;

    if (activeTouchLink) {
      activeTouchLink.classList.remove("is-touch-active");
    }

    if (link) {
      link.classList.add("is-touch-active");
    }

    activeTouchLink = link;
  }

  function updateTouchLink(clientX, clientY) {
    if (!drawer.classList.contains("is-open")) return;

    const element = document.elementFromPoint(clientX, clientY);

    const link = element?.closest(".maison-drawer__link");

    if (!link || !drawer.contains(link)) {
      setTouchActiveLink(null);
      return;
    }

    setTouchActiveLink(link);
  }

  drawer.addEventListener(
    "touchstart",
    (event) => {
      if (!drawer.classList.contains("is-open")) return;

      const touch = event.touches[0];

      if (!touch) return;

      updateTouchLink(touch.clientX, touch.clientY);
    },
    { passive: true },
  );

  drawer.addEventListener(
    "touchmove",
    (event) => {
      if (!drawer.classList.contains("is-open")) return;

      const touch = event.touches[0];

      if (!touch) return;

      updateTouchLink(touch.clientX, touch.clientY);
    },
    { passive: true },
  );

  drawer.addEventListener(
    "touchend",
    () => {
      setTimeout(() => {
        setTouchActiveLink(null);
      }, 120);
    },
    { passive: true },
  );

  drawer.addEventListener(
    "touchcancel",
    () => {
      setTouchActiveLink(null);
    },
    { passive: true },
  );

  function openDrawer() {
    drawer.classList.add("is-open");

    drawer.classList.remove("is-ready");

    drawer.setAttribute("aria-hidden", "false");

    document.body.classList.add("maison-drawer-open");

    const isMobile = window.matchMedia("(max-width: 749px)").matches;

    const startDelay = isMobile ? 0.18 : 0.22;

    const stepDelay = isMobile ? 0.065 : 0.08;

    links.forEach((link, index) => {
      const delay = startDelay + index * stepDelay;

      link.style.setProperty("--delay", `${delay}s`);
    });

    const lastDelay = startDelay + (links.length - 1) * stepDelay;

    // Proyecto 04 — Motion: 0.65s replica a propósito la transición real
    // de .maison-drawer__link en maison-drawer.css (transform: 0.65s
    // var(--ms-signature-ease)) — ese archivo ya documenta que 0.65s no
    // coincide con ningún --ms-motion-* exacto y se conserva literal
    // (decisión deliberada, no un olvido). Este valor es la clasificación
    // SIGNATURE/EDITORIAL del sistema de motion (misma curva --ms-signature-ease
    // que el borde dorado de las Identity Cards): el primer despliegue de
    // el menú es un momento de marca, no una micro-interacción estándar.
    // Debe mantenerse en JS sincronizado a mano con el CSS citado arriba —
    // no se movió a una custom property porque introducir lectura de
    // getComputedStyle() en un flujo de navegación en producción es un
    // riesgo mayor que mantener un número replicado y documentado en dos
    // lugares.
    const animationDuration = 0.65;

    const readyDelay = (lastDelay + animationDuration) * 1000;

    window.setTimeout(() => {
      if (drawer.classList.contains("is-open")) {
        drawer.classList.add("is-ready");
      }
    }, readyDelay);
  }

  function closeDrawer() {
    drawer.classList.remove("is-open","is-ready");

    drawer.setAttribute("aria-hidden", "true");

    document.body.classList.remove("maison-drawer-open");

    setTouchActiveLink(null);
  }

  openButtons.forEach((button) => {
    button.addEventListener(
      "click",

      openDrawer,
    );
  });

  closeButton?.addEventListener("click", closeDrawer);

  drawer.addEventListener("pointerdown", (event) => {
    if (!event.target.closest(".maison-drawer__panel")) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeDrawer();
    }
  });
});
